import { render } from "./TabsContentContainer.vue?vue&type=template&id=48f6d51e&scoped=true"
import script from "./TabsContentContainer.vue?vue&type=script&lang=js"
export * from "./TabsContentContainer.vue?vue&type=script&lang=js"

import "./TabsContentContainer.vue?vue&type=style&index=0&id=48f6d51e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f6d51e"]])

export default __exports__